import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToolboxModule} from '../shared/toolbox/toolbox.module';
import {RetailerProfileComponent} from './retailer-profile/retailer-profile.component';
import {ListProfileComponent} from './list-profile/list-profile.component';
import {ProfileWrapperComponent} from './profile-wrapper/profile-wrapper.component';
import {ChartsModule} from '../shared/toolbox/charts/charts.module';
import {ClipboardModule} from '@angular/cdk/clipboard'
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {DialogComponent} from '../shared/toolbox/dialogs/dialog/dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {CompareDialogComponent} from '../shared/toolbox/dialogs/compare-dialog/compare-dialog.component';
import {ChartWrapperComponent} from '../shared/toolbox/charts/chart-wrapper/chart-wrapper.component';
import {IconCardComponent} from './dashboard/elements/icon-card/icon-card.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {LoaderComponent} from '../shared/toolbox/loader/loader.component';
import {EchelonComponent} from '../shared/toolbox/echelon/echelon.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {EditOverlayComponent} from './dashboard/elements/edit-overlay/edit-overlay.component';
import {ExploreModule} from '../explore/explore.module';
import {ExplorerComponent} from '../explore/explorer/explorer.component';
import {
  TabularDataDownloadDialogComponent
} from "../shared/toolbox/dialogs/tabular-data-download-dialog/tabular-data-download-dialog.component";
import {ProfileTopMatterComponent} from "./profile-top-matter/profile-top-matter.component";
import { SectorProfileComponent } from './sector-profile/sector-profile.component';
import { RegionProfileComponent } from './region-profile/region-profile.component';


@NgModule({
  declarations: [
    RetailerProfileComponent,
    ListProfileComponent,
    ProfileWrapperComponent,
    SectorProfileComponent,
    RegionProfileComponent,
  ],
  imports: [
    LoaderComponent,
    EchelonComponent,
    CompareDialogComponent,
    ToolboxModule,
    CommonModule,
    ChartsModule,
    ClipboardModule,
    MatTooltipModule,
    MatSnackBarModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    IconCardComponent,
    FontAwesomeModule,
    DialogComponent,
    EditOverlayComponent,
    DashboardComponent,
    ExploreModule,
    TabularDataDownloadDialogComponent,
    ProfileTopMatterComponent

  ],
  providers: [DialogComponent, CompareDialogComponent, ChartWrapperComponent],
  exports: [
    RetailerProfileComponent,
    ProfileWrapperComponent,
    ListProfileComponent,
    ExplorerComponent
  ],
})
export class ProfilesModule {
}
